/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskLog
 */
export interface TaskLog {
    /**
     * 
     * @type {string}
     * @memberof TaskLog
     */
    log: string;
}

export function TaskLogFromJSON(json: any): TaskLog {
    return TaskLogFromJSONTyped(json, false);
}

export function TaskLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskLog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'log': json['log'],
    };
}

export function TaskLogToJSON(value?: TaskLog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'log': value.log,
    };
}


